const servicesData = [
  {
    id: 'pants',
    title: 'Pants',
    description: 'Professional pants alterations for the perfect fit.',
    image: 'pants',
    services: [
      { name: 'Button / Snap Replacement', desc: 'Replace or repair waistband buttons or snaps for secure closure.' },
      { name: 'Lining Repair', desc: 'Fix or replace interior lining for comfort and durability.' },
      { name: 'Hem (Plain / Jean / Euro / Cuff / 2" Cuff)', desc: 'Shorten or lengthen pants using the appropriate hem style.' },
      { name: 'Double Stitch', desc: 'Reinforce seams with double stitching for strength.' },
      { name: 'Lengthen', desc: 'Increase pant length when fabric allowance is available.' },
      { name: 'Zipper Replacement', desc: 'Remove and replace broken or worn zippers.' },
      { name: 'Taper Hip / Leg', desc: 'Slim pants at the hips or legs for a tailored fit.' },
      { name: 'Mark & Dark', desc: 'Adjust crease or refine pant press lines.' },
      { name: 'Crotch Repair', desc: 'Reinforce or repair worn crotch seams.' },
      { name: 'Waist In / Waist Out', desc: 'Take in or let out the waistband.' },
      { name: 'Double & Vent', desc: 'Adjust vented pant openings.' },
      { name: 'Pocket Repair', desc: 'Fix or replace damaged pockets.' },
      { name: 'Lower Waist', desc: 'Reduce rise for improved fit.' },
    ],
  },
  {
    id: 't-shirts',
    title: 'T-Shirts',
    description: 'Simple alterations to perfect your casual wear.',
    image: 'tshirts',
    services: [
      { name: 'Sleeve Shorten', desc: 'Adjust sleeve length.' },
      { name: 'Side In', desc: 'Take in sides for a slimmer fit.' },
      { name: 'Bottom Hem', desc: 'Shorten shirt length while maintaining original look.' },
    ],
  },
  {
    id: 'winter-coats',
    title: 'Winter Coats',
    description: 'Keep warm in style with perfectly fitted outerwear.',
    image: 'coats',
    services: [
      { name: 'Slider Repair', desc: 'Fix or replace zipper sliders.' },
      { name: 'Sleeve Alteration', desc: 'Shorten or lengthen sleeves.' },
      { name: 'Zipper Replacement', desc: 'Replace full-length coat zippers.' },
      { name: 'Side In', desc: 'Tailor coat sides for better fit.' },
      { name: 'Bottom Adjustment', desc: 'Shorten coat length.' },
      { name: 'Re-Lining', desc: 'Replace interior lining.' },
      { name: 'Lengthen', desc: 'Extend coat length if fabric allows.' },
    ],
  },
  {
    id: 'shirts',
    title: 'Shirts',
    description: 'Dress shirt and button-up alterations for a polished look.',
    image: 'shirts',
    services: [
      { name: 'Button Replacement', desc: 'Replace missing or damaged buttons.' },
      { name: 'Half Sleeve / Full Sleeve', desc: 'Adjust sleeve length.' },
      { name: 'Bottom Hem', desc: 'Shorten shirt length.' },
      { name: 'Collar Adjustment', desc: 'Repair or reshape collar.' },
      { name: 'Side In / Fold Side In', desc: 'Tailor shirt width.' },
      { name: 'Placket Adjustment', desc: 'Modify placket alignment if required.' },
    ],
  },
  {
    id: 'Other dress Alterations',
    title: 'Regular Dresses',
    description: 'Other msc dress alterations. We provide a variety of alterations for your needs.',
    image: 'dresses',
    services: [
      { name: 'Eye & Hook', desc: 'Install hooks for secure closure.' },
      { name: 'Lining', desc: 'Add or repair lining.' },
      { name: 'Strap Adjustment', desc: 'Shorten or alter dress straps.' },
      { name: 'Side In', desc: 'Take in dress for better fit.' },
      { name: 'Zipper Replacement', desc: 'Replace broken or tight zippers.' },
      { name: 'Bottom Hem', desc: 'Shorten dress length.' },
      { name: 'Loop Addition', desc: 'Add hanging or bustle loops.' },
    ],
  },
  {
    id: 'suits',
    title: 'Suits',
    description: 'Expert tailoring for a sharp, professional appearance.',
    image: 'suits',
    services: [
      { name: 'Button Replacement', desc: 'Repair or replace suit buttons.' },
      { name: 'Sleeve Alteration', desc: 'Adjust sleeve length.' },
      { name: 'Side In / Side Out', desc: 'Tailor jacket width.' },
      { name: 'Center Seam Adjustment', desc: 'Alter back seam for fit.' },
      { name: 'Lengthen Jacket', desc: 'Extend jacket length if possible.' },
      { name: 'Lower Collar', desc: 'Improve collar lay.' },
      { name: 'Move Shoulder', desc: 'Adjust shoulder alignment.' },
      { name: 'Bottom Adjustment', desc: 'Shorten jacket length.' },
      { name: 'Re-Lining', desc: 'Replace suit lining.' },
    ],
  },
  {
    id: 'skirts',
    title: 'Skirts',
    description: 'Skirt alterations for the perfect length and fit.',
    image: 'skirts',
    services: [
      { name: 'Lining Repair', desc: 'Fix or replace skirt lining.' },
      { name: 'Side In', desc: 'Take in skirt waist or hips.' },
      { name: 'Bottom Hem', desc: 'Shorten skirt length.' },
      { name: 'Leather Side In / Bottom', desc: 'Leather specific tailoring and hemming.' },
    ],
  },
  {
    id: 'leather-jackets',
    title: 'Leather Jackets',
    description: 'Specialized leather jacket alterations and repairs.',
    image: 'leather',
    services: [
      { name: 'Snap / Patch Repair', desc: 'Replace snaps or patch damaged areas.' },
      { name: 'Slider Repair', desc: 'Fix zipper slider.' },
      { name: 'New Pocket', desc: 'Add or replace pockets.' },
      { name: 'Sleeve Alteration', desc: 'Adjust sleeve length.' },
      { name: 'Sleeve & Vent Zipper', desc: 'Replace sleeve or vent zippers.' },
      { name: 'Zipper Replacement', desc: 'Full zipper replacement.' },
      { name: 'Side In / Side Out', desc: 'Tailor fit through body.' },
      { name: 'Bottom Adjustment', desc: 'Shorten jacket length.' },
      { name: 'Move Shoulder', desc: 'Reshape shoulder fit.' },
      { name: 'Re-Lining', desc: 'Replace interior lining.' },
    ],
  },
  {
    id: 'leather-pants',
    title: 'Leather Pants',
    description: 'Expert leather pants alterations and adjustments.',
    image: 'leather',
    services: [
      { name: 'Plain Hem / Hem with Zipper', desc: 'Shorten leather pants with or without zipper adjustment.' },
      { name: 'Lining Addition', desc: 'Add interior lining.' },
      { name: 'Waist In / Waist Out', desc: 'Adjust waistband size.' },
      { name: 'Invisible Zipper', desc: 'Install concealed zipper.' },
      { name: 'Zipper Replacement', desc: 'Replace standard zipper.' },
    ],
  },
  {
    id: 'prom-bridesmaid',
    title: 'Prom & Bridesmaid Dresses',
    description: 'Look stunning for your special occasion.',
    image: 'dresses',
    services: [
      { name: 'Eye & Hook', desc: 'Secure bodice closures.' },
      { name: 'Strap Adjustment', desc: 'Alter straps for proper fit.' },
      { name: 'Loop Addition', desc: 'Add bustle or support loops.' },
      { name: 'Side In', desc: 'Tailor dress shape.' },
      { name: 'Bottom Hem', desc: 'Hem prom dresses to shorten length.' },
    ],
  },
  {
    id: 'wedding-dresses',
    title: 'Wedding Dresses',
    description: 'Make your dream dress fit.',
    image: 'dresses',
    services: [
      { name: 'Bustle', desc: 'Add bustle for train management.' },
      { name: 'Loop Addition', desc: 'Add support or bustle loops.' },
      { name: 'Side In', desc: 'Tailor bodice and waist.' },
      { name: 'Bottom Hem', desc: 'Hem wedding gowns to shorten length.' },
    ],
  },
  {
    id: 'vest',
    title: 'Vest',
    description: 'Vest alterations for a tailored look.',
    image: 'suits',
    services: [
      { name: 'Side In', desc: 'Tailor vest for slimmer fit.' },
      { name: 'Shorten Bottom', desc: 'Adjust vest length.' },
    ],
  },
  {
    id: 'curtains',
    title: 'Curtains',
    description: 'Professional curtain hemming and alterations.',
    image: 'curtains',
    services: [
      { name: 'Sew Together', desc: 'Join curtain panels.' },
      { name: 'Single / Double Panels (by length)', desc: 'Hem curtains based on panel count and size.' },
    ],
  },
  {
    id: 'patch-service',
    title: 'Patch Service',
    description: 'Secure patch application for any garment.',
    image: 'patch',
    services: [
      { name: 'Patch Application', desc: 'Attach patches securely to garments.' },
    ],
  },
];

export default servicesData;
